import { Fragment } from 'react'
import { Link } from '@chakra-ui/react'

import { List } from '@/features/landingPage/components/shared'

export const PRIVACY_POLICY = {
  title: 'นโยบายความเป็นส่วนตัว',
  checkActive: ['privacy'],
  linkTo: 'privacy',
  subMenus: [
    {
      title: 'ข้อมูลที่ทางเราเก็บรวบรวมโดยอัตโนมัติ',
      scrollTo: 'automatic-collection-of-information',
      content: (
        <Fragment>
          <p>
            เมื่อท่านเยี่ยมชมเว็บไซต์ PDPA Pro
            เซิร์ฟเวอร์ของเราจะบันทึกข้อมูลที่เบราว์เซอร์ของท่านส่งโดยอัตโนมัติ
            ข้อมูลเหล่านั้นอาจได้แก่ IP Address ของอุปกรณ์ท่าน
            ชนิดและเวอร์ชั่นของเบราว์เซอร์ ชนิดและเวอร์ชั่นของระบบปฏิบัติการ
            ภาษาที่ท่านเลือกใช้หรือหน้าเว็บไซต์ที่ท่านได้เยี่ยมชมก่อนเข้าสู่เว็บไซต์
            PDPA Pro หน้าเว็บไซต์ PDPA Pro ของเราที่ท่านได้เยี่ยมชม
            ระยะเวลาที่เยี่ยมชมเว็บไซต์เหล่านั้น ข้อมูลที่ท่านค้นหาบนเว็บไซต์
            PDPA Pro ของเรา วันและเวลาที่เข้าชม และสถิติอื่น ๆ
          </p>
          <p>
            ข้อมูลที่ถูกรวบรวมโดยอัตโนมัติจะใช้เพื่อระบุการละเมิดที่อาจเกิดขึ้นและสร้างข้อมูลทางสถิติเกี่ยวกับการใช้งานเว็บไซต์
            PDPA Pro
            โดยข้อมูลทางสถิตินี้จะไม่ถูกรวบรวมในลักษณะที่ทำให้ระบุผู้ใช้รายใดรายหนึ่งของระบบได้
          </p>
        </Fragment>
      ),
    },
    {
      title: 'การเก็บรวบรวมข้อมูลส่วนบุคคล',
      scrollTo: 'collection-of-personal-information',
      content: (
        <Fragment>
          <p>
            ท่านสามารถเยี่ยมชมเว็บไซต์ PDPA Pro
            โดยไม่ต้องบอกเราว่าท่านคือใครหรือเปิดเผยข้อมูลใด ๆ
            ที่ทำให้บุคคลอื่นสามารถระบุตัวตนของท่านได้อย่างเฉพาะเจาะจง
            อย่างไรก็ตาม ท่านจะถูกสอบถามให้บอกกล่าวข้อมูลส่วนบุคคลบางอย่าง (เช่น
            ชื่อและอีเมลของท่าน)
            หากท่านมีความประสงค์ที่จะใช้ระบบการทำงานบางตัวของเว็บไซต์ PDPA Pro
            เราได้รับและจัดเก็บข้อมูลใด ๆ
            ที่ท่านได้ให้เราไว้โดยที่ท่านรับรู้เมื่อท่านได้ทำการสร้างบัญชีผู้ใช้
            ประกาศเนื้อหา ทำการสั่งซื้อ หรือกรอกแบบฟอร์มบนเว็บไซต์ PDPA Pro
            เมื่อมีความจำเป็นข้อมูลเหล่านั้นอาจมีดังนี้
          </p>
          <List>
            <li>
              ข้อมูลส่วนบุคคล เช่น ชื่อ นามสกุล อายุ วันเดือนปีเกิด
              เลขประจำตัวประชาชน/หนังสือเดินทาง
            </li>
            <li>ข้อมูลการติดต่อ เช่น อีเมล ที่อยู่ หมายเลขโทรศัพท์</li>
            <li>
              ข้อมูลบัญชี เช่น ชื่อผู้ใช้งาน รหัสผู้ใช้งานที่เป็นเอกลักษณ์
              รหัสผ่าน
            </li>
            <li>
              หลักฐานการแสดงตัวตน เช่น สำเนาบัตรประจำตัวประชาชน
              สำเนาหนังสือเดินทาง
            </li>
            <li>
              ข้อมูลการทำธุรกรรมและการเงิน เช่น รายละเอียดบัตรเครดิต บัญชีธนาคาร
              ประวัติการสั่งซื้อ
            </li>
            <li>
              ข้อมูลอื่น ๆ ที่ท่านยินยอมนำส่งให้แก่เรา เช่น บทความ รูปภาพ
              ภาพเคลื่อนไหว ข้อเสนอแนะ
              และข้อมูลอื่นใดที่ถือว่าเป็นข้อมูลส่วนบุคคลตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล
              เป็นต้น
            </li>
          </List>
          <p>
            ท่านสามารถเลือกที่จะไม่ให้ข้อมูลส่วนบุคคลของท่านแก่เราได้
            แต่ท่านจะไม่ได้รับความสะดวกในการใช้งานระบบการทำงานบางส่วนของเว็บไซต์
            PDPA Pro และบริการ
            ผู้ใช้ที่ยังไม่แน่ใจว่าข้อมูลส่วนบุคคลใดที่มีความจำเป็นสามารถติดต่อเพื่อสอบถามเราได้
          </p>
        </Fragment>
      ),
    },
    {
      title: 'การจัดการข้อมูลส่วนบุคคล',
      scrollTo: 'managing-personal-information',
      content: (
        <p>
          ท่านสามารถทำการลบข้อมูลส่วนบุคคลที่เราได้เก็บเกี่ยวกับตัวท่านได้
          ข้อมูลส่วนบุคคลที่ท่านสามารถทำการลบได้จะมีการเปลี่ยนแปลงไปตามการเปลี่ยนแปลงของเว็บไซต์
          PDPA Pro หรือการบริการ อย่างไรก็ตาม
          เมื่อท่านได้ลบข้อมูลส่วนบุคคลของท่านแล้ว
          เราอาจเก็บรักษาไว้ซึ่งสำเนาของข้อมูลส่วนบุคคลที่ไม่มีการแก้ไขไว้ในบันทึกของเราไว้เป็นระยะเวลาที่จำเป็นสำหรับการปฏิบัติหน้าที่ของเราต่อพันธมิตรหรือหุ้นส่วนของเรา
          และวัตถุประสงค์ที่ได้ระบุไว้ด้านล่างนี้
          หากท่านมีความประสงค์ที่จะลบข้อมูลส่วนบุคคลของท่านหรือลบบัญชีการใช้งานบนเว็บไซต์
          PDPA Pro ของท่านเป็นการถาวร
          ท่านสามารถทำได้โดยเข้าหน้าการตั้งค่าในบัญชีการใช้งานของท่านบนเว็บไซต์
          PDPA Pro หรือทำการติดต่อเราตามความสะดวก
        </p>
      ),
    },
    {
      title: 'การจัดเก็บข้อมูลส่วนบุคคล',
      scrollTo: 'Storage of Personal information',
      content: (
        <Fragment>
          <p>
            เราจะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้ตามระยะเวลาที่จำเป็นสำหรับการปฏิบัติตามหน้าที่ตามกฎหมายของเรา
            ยุติข้อพิพาท และเพื่อการบังคับใช้สัญญาและข้อกำหนดและเงื่อนไขของเรา
            เว้นเสียแต่มีความจำเป็นที่จะต้องเก็บต่อไปหรือตามที่กฎหมายกำหนด
            เราอาจใช้ข้อมูลที่รวมขึ้นที่ได้มาจากการรวบรวมข้อมูลส่วนบุคคลของท่านที่ได้ทำให้เป็นปัจจุบันหรือลบทิ้งไปแต่เราจะไม่นำมาใช้ในทางที่สามารถระบุตัวตนของท่านได้
            เมื่อครบกำหนดระยะเวลาการจัดเก็บ ข้อมูลส่วนบุคคลจะถูกลบทิ้ง ดังนั้น
            สิทธิขอเข้าถึง สิทธิขอให้ลบ สิทธิขอให้แก้ไข สิทธิขอถ่ายโอนข้อมูล
            จะไม่สามารถบังคับใช้ได้เมื่อครบกำหนดระยะเวลาการจัดเก็บ
          </p>
          <p>
            ข้อมูลส่วนบุคคลของท่านจะถูกส่งไปนอกราชอาณาจักรไทยเนื่องจากระบบโครงสร้างพื้นฐานของเราอยู่ที่ประเทศสิงคโปร์
          </p>
        </Fragment>
      ),
    },
    {
      title: 'การใช้และประมวลผลข้อมูลส่วนบุคคลที่เก็บรวบรวม',
      scrollTo: 'use-and-processing-of-collected-information',
      content: (
        <Fragment>
          <p>
            เพื่อทำให้เว็บไซต์ PDPA Pro
            และบริการสามารถให้ท่านใช้งานได้หรือเพื่อปฏิบัติตามหน้าที่ตามกฎหมาย
            เราจึงมีความจำเป็นจะต้องเก็บรวบรวมข้อมูลส่วนบุคคลของท่านบางส่วน
            หากท่านไม่ให้เราเก็บรวบรวมข้อมูลที่เราร้องขอ
            เราอาจจะไม่สามารถจัดเตรียมผลิตภัณฑ์หรือบริการที่ท่านร้องขอได้
            ข้อมูลบางส่วนที่เราได้เก็บรวบรวมนั้นได้มาจากท่านโดยตรงผ่านเว็บไซต์
            PDPA Pro อย่างไรก็ตาม
            เราอาจมีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากแหล่งข้อมูลอื่นมีอยู่
            รวมถึงแต่ไม่จำกัดเพียง กิจกรรมการแนะนำผู้ซื้อรายใหม่ของบริษัท
            เอ็นเดต้าธอธ จำกัด สื่อสังคมออนไลน์ อีเมล
            ข้อมูลส่วนบุคคลที่เราได้เก็บรวบรวมจากท่านอาจนำมาใช้สำหรับวัตถุประสงค์ดังต่อไปนี้
          </p>
          <List>
            <li>เพื่อสร้างและจัดการบัญชีผู้ใช้งาน</li>
            <li>เพื่อทำการและจัดการคำสั่งซื้อ</li>
            <li>เพื่อจัดส่งผลิตภัณฑ์หรือบริการ</li>
            <li>เพื่อปรับปรุงผลิตภัณฑ์หรือบริการให้ดียิ่งขึ้น</li>
            <li>เพื่อส่งข้อมูลการดูแลจัดการ</li>
            <li>เพื่อส่งข้อมูลการสื่อสารทางการตลาดหรือรายการส่งเสริมการขาย</li>
            <li>เพื่อตอบสนองต่อข้อสงสัยและนำเสนอการช่วยเหลือ</li>
            <li>เพื่อร้องขอข้อเสนอแนะจากผู้ใช้</li>
            <li>เพื่อปรับปรุงประสบการณ์การใช้งานของผู้ใช้ให้ดียิ่งขึ้น</li>
            <li>
              เพื่อโพสต์หรือประชาสัมพันธ์ความพึงพอใจของท่านที่มีเกี่ยวกับผลิตภัณฑ์และบริการของเรา
            </li>
            <li>เพื่อบังคับใช้ข้อตกลงและเงื่อนไขและนโยบายต่าง ๆ</li>
            <li>เพื่อปกป้องจากผู้ใช้ที่ไม่ชอบและอันตราย</li>
            <li>
              เพื่อตอบสนองต่อข้อเรียกร้องทางกฎหมายและหลีกเลี่ยงความเสียหาย
            </li>
            <li>เพื่อดำเนินการและจัดการเว็บไซต์ PDPA Pro และบริการ</li>
            <li>
              เพื่อมีส่วนร่วมในกิจกรรมอื่นใดที่เกี่ยวข้องกับเว็บไซต์และบริการของ
              PDPA Pro
            </li>
          </List>
          <p>
            การประมวลผลข้อมูลส่วนบุคคลของท่านขึ้นอยู่กับวิธีการที่ใช้เว็บไซต์
            PDPA Pro สถานที่ที่ท่านอยู่ และหากหนึ่งในการกระทำดังต่อไปนี้ (1)
            ท่านได้ให้ความยินยอมสำหรับหนึ่งหรือมากกว่าหนึ่งวัตถุประสงค์ที่เจาะจง
            อย่างไรก็ตาม
            การกระทำนี้จะไม่บังคับใช้หากข้อมูลส่วนบุคคลนั้นตกอยู่ภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคลแห่งประเทศไทย
            (PDPA) (2) ข้อมูลนั้นจำเป็นเพื่อการปฏิบัติตามสัญญาระหว่างท่าน
            และ/หรือเพื่อการปฏิบัติก่อนการเข้าทำสัญญา (3)
            การประมวลผลข้อมูลนั้นมีความจำเป็นเพื่อการปฏิบัติตามกฎหมายที่ท่านอยู่ภายใต้
            (4)
            การประมวลผลข้อมูลนั้นเกี่ยวข้องกับการดำเนินภารกิจเพื่อประโยชน์สาธารณะของเรา
            หรือปฏิบัติหน้าที่ในการใช้อำนาจรัฐที่ได้มอบให้แก่เรา (5)
            การประมวลผลข้อมูลนั้นเป็นการจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายของเรา
            หรือของบุคคลหรือนิติบุคคลอื่น
          </p>
          <p>
            โปรดทราบว่าภายใต้บางสถานการณ์
            เราอาจได้รับอนุญาตให้ประมวลผลข้อมูลส่วนบุคคลของท่านไปจนกว่าท่านจะทำการคัดค้านการประมวลผลข้อมูลนั้น
            (แจ้งยกเลิก (opt-out)) โดยไม่ต้องอ้างอิงความยินยอมหรือฐานกฎหมายใด ๆ
            ที่ระบุไว้ ในกรณีใดก็ตาม
            เรายินดีที่จะชี้แจงฐานกฎหมายที่เราใช้ในการประมวลผลข้อมูลอย่างเจาะจง
            และในทางเจาะจงว่าการประมวลผลข้อมูลส่วนบุคคลนั้นเป็นไปตามข้อบังคับทางกฎหมายหรือตามหน้าที่ของสัญญา
            หรือมีความจำเป็นสำหรับการเข้าทำสัญญา
          </p>
          <p>
            เราไม่เคยทำการขายข้อมูลของท่านให้แก่บุคคลอื่น
            เราได้ใช้บริการของผู้ประมวลข้อมูลภายนอกดังนี้
          </p>
          <List>
            {[
              'Amazon Web Services (โครงสร้างพื้นฐานและบริการ/อีเมล เว็บโฮสติ้ง) [ประเทศสิงคโปร์]',
              'Slack [ประเทศสหรัฐอเมริกา]',
              'Crisp [ประเทศสหรัฐอเมริกา]',
              'Hotjar [ประเทศสหรัฐอเมริกา]',
              'Howuku [ประเทศสหรัฐอเมริกา]',
              'Pipedrive [ประเทศสหรัฐอเมริกา]',
              'Google Workspace [ประเทศสหรัฐอเมริกา/ประเทศสิงคโปร์/ทั่วโลก]',
              'Google Analytics [ประเทศสหรัฐอเมริกา/ประเทศสิงคโปร์/ทั่วโลก]',
              'Stripe [ประเทศสหรัฐอเมริกา/ประเทศญี่ปุ่น]',
              'Facebook Pixel [ประเทศสหรัฐอเมริกา]',
              'SurveySensum [ประเทศสหรัฐอเมริกา]',
              'Typeform [ประเทศสหรัฐอเมริกา/สหภาพยุโรป]',
              'Wiser Notify [ประเทศสหรัฐอเมริกา]',
              'Cookie Wow [ประเทศสิงคโปร์/ประเทศไทย]',
              'PDPA Form [ประเทศสิงคโปร์/ประเทศไทย]',
              'Primal [ประเทศไทย]',
            ].map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </List>
        </Fragment>
      ),
    },
    {
      title: 'การส่งหรือโอนข้อมูลส่วนบุคคลไปต่างประเทศและการจัดเก็บ',
      scrollTo: 'information-transfer-and-storage',
      content: (
        <Fragment>
          <p>
            การส่งหรือโอนข้อมูลอาจมีความเกี่ยวข้องกับการโอนและจัดเก็บข้อมูลไปยังประเทศอื่นที่ไม่ใช่ประเทศของท่านโดยขึ้นอยู่กับตำแหน่งของท่านเอง
            หากมีการส่งหรือโอนข้อมูลใดเกิดขึ้น
            ท่านสามารถตรวจสอบในข้อที่เกี่ยวข้องของเอกสารฉบับนี้หรือสอบถามเราโดยใช้ข้อมูลที่เราจัดเตรียมให้ในข้อการติดต่อ
          </p>
          <p>
            ข้อมูลการใช้งานของท่านถูกจัดเก็บไว้อย่างปลอดภัยในประเทศสิงคโปร์ PDPA
            Pro โฮสต์โครงสร้างพื้นฐานหลักไว้ในประเทศสิงคโปร์
            เราได้ปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคลแห่งประเทศไทย
            พ.ศ. 2562 (2019) และได้ให้สิทธิร้องขอได้ตามที่กฎหมายกำหนด
          </p>
          <p>
            แม้ว่าเราจะมีการโฮสต์ข้อมูลส่วนบุคคลบางส่วนอยู่นอกประเทศไทย
            เรายังคงปฏิบัติตามมาตรการป้องกันข้อมูลที่เหมาะสมและเลือกใช้ศูนย์กลางข้อมูลที่มีมาตรฐานที่สูงสุดในด้านการป้องกันและความพร้อมทางด้านการใช้งาน
            เนื่องจากเราไม่สามารถหาศูนย์ข้อมูลใด ๆ
            ในประเทศไทยที่ตรงตามมาตรฐานได้
            เราจึงจำเป็นจะต้องโฮสต์โครงสร้างพื้นฐานหลักของเราไว้ในประเทศสิงคโปร์สำหรับสถานที่เพื่อกู้คืนระบบในขณะที่ข้อมูลส่วนบุคคลบางส่วนที่ใช้ในการเรียกเก็บเงินจะถูกจัดเก็บและประมวลผลข้อมูลในประเทศไทย
          </p>
        </Fragment>
      ),
    },
    {
      title: 'สิทธิของผู้ใช้',
      scrollTo: 'the-right-of-users',
      content: (
        <p>
          ท่านสามารถใช้สิทธิบางประการที่ท่านมีเกี่ยวกับข้อมูลของท่านที่ได้มีการประมวลผลโดยเรา
          โดยเฉพาะอย่างยิ่ง ท่านมีสิทธิดังต่อไปนี้ (1)
          ท่านมีสิทธิในการเพิกถอนความยินยอมที่ท่านให้ไว้ก่อนหน้าในการประมวลผลข้อมูลของท่าน
          อย่างไรก็ตาม
          การเพิกถอนความยินยอมดังกล่าวย่อมไม่ส่งผลกระทบต่อการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมไว้ก่อนหน้าโดยชอบด้วยกฎหมาย
          (2) ท่านมีสิทธิขอคัดค้านการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลของท่านในเวลาใดก็ได้ เว้นแต่ว่าการเก็บรวบรวม
          ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลของท่านนั้นถูกทำขึ้นเพื่อการดำเนินงานที่จำเป็นภายใต้ประโยชน์โดยชอบด้วยกฎหมายของเราหรือของบุคคลหรือนิติบุคคลอื่น
          หรือเพื่อการดำเนินการตามภารกิจเพื่อสาธารณประโยชน์ และการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลนั้นไม่เกินขอบเขตที่ท่านสามารถคาดหมายได้อย่างสมเหตุสมผล
          (3) ท่านมีสิทธิในการรับทราบข้อมูลของท่านที่ได้มีการประมวลผลโดยเรา
          ได้รับมาจากการเปิดเผยที่เกี่ยวกับการประมวลผลข้อมูลและขอให้เราทำสำเนาดังกล่าวให้แก่ท่าน
          (4) ท่านมีสิทธิยืนยันความถูกต้องในข้อมูลของท่านและร้องขอให้เรา
          แก้ไขข้อมูลส่วนบุคคลของท่านเพื่อให้ข้อมูลส่วนบุคคลดังกล่าวถูกต้องและเป็นปัจจุบัน
          (5) ท่านมีสิทธิในการระงับการประมวลผลข้อมูลของท่าน ในกรณีดังกล่าว
          เราจะไม่ประมวลผลข้อมูลของท่านนอกเหนือจากการจัดเก็บข้อมูลเพียงเท่านั้น
          (6)
          ท่านมีสิทธิในบางกรณีในการขอให้เราลบข้อมูลส่วนบุคคลของท่านออกจากการจัดเก็บของเรา
          (7)
          ท่านมีสิทธิขอรับข้อมูลส่วนบุคคลของท่านในรูปแบบที่สามารถอ่านหรือใช้งานได้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้
          และ (หากสามารถทำได้)
          ให้เราส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นเมื่อสามารถทำได้ด้วยวิธีการดังกล่าว
          สิทธิในข้อนี้จะสามารถทำได้หากข้อมูลของท่านได้ถูกประมวลผลในรูปแบบอัติโนมัติและได้ประมวลผลตามฐานความยินยอม
          ฐานสัญญาที่ท่านเป็นคู่สัญญาหรือก่อนการเข้าทำสัญญา และ (8)
          ท่านมีสิทธิร้องเรียนต่อผู้มีอำนาจตามกฎหมายที่เกี่ยวข้อง
          หากท่านเชื่อว่าการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน
          เป็นการกระทำในลักษณะที่ฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายที่เกี่ยวข้อง
        </p>
      ),
    },
    {
      title: 'วิธีการใช้สิทธิ',
      scrollTo: 'how-to-exercise-these-rights',
      content: (
        <Fragment>
          <p>
            การร้องขอใช้สิทธิใด ๆ
            ก็ตามของผู้ใช้สามารถทำได้โดยร้องขอไปยังเราผ่านช่องทางการติดต่อที่เราจัดเตรียมไว้ให้ภายใต้เอกสารฉบับนี้
            การร้องขอใช้สิทธินี้สามารถใช้ได้โดยไม่เสียค่าใช้จ่ายและจะดำเนินการให้โดยเร็วที่สุดโดยเรา
          </p>
          <p>
            แบบฟอร์มออนไลน์สามารถทำการกรอกได้ที่{' '}
            <Link isExternal href="https://ndatathoth.pdpaform.com">
              https://ndatathoth.pdpaform.com
            </Link>{' '}
            (โปรดระบุว่าเป็นการร้องขอสำหรับเว็บไซต์ PDPA Pro)
          </p>
        </Fragment>
      ),
    },
    {
      title: 'การเรียกชำระเงินและการชำระเงิน',
      scrollTo: 'billing-and-payments',
      content: (
        <p>
          เรามีการใช้ผู้ประมวลผลในการชำระเงินที่เป็นบุคคลที่สามเพื่อช่วยเราในการประมวลผลข้อมูลการชำระเงินของท่านให้ปลอดภัย
          การใช้ข้อมูลส่วนบุคคลของท่านโดยผู้ประมวลผลบุคคลที่สามดังกล่าวอยู่จะตกอยู่ภายใต้นโยบายความเป็นส่วนตัวที่เกี่ยวข้องของบุคคลนั้น
          ซึ่งอาจมีหรือไม่มีการคุ้มครองความเป็นส่วนตัวที่มีการป้องกันตามนโยบายนี้
          เราจึงขอแนะนำให้ท่านตรวจสอบนโยบายความเป็นส่วนตัวที่เกี่ยวข้องของบุคคลนั้น
        </p>
      ),
    },
    {
      title: 'ผู้ให้บริการในผลิตภัณฑ์และบริการ',
      scrollTo: 'products-and-service-providers',
      content: (
        <p>
          เราอาจมีการเข้าทำสัญญาร่วมกับบริษัทอื่นเพื่อจัดเตรียมผลิตภัณฑ์หรือบริการบางอย่าง
          ผู้ให้บริการเหล่านี้จะไม่ได้รับอนุญาตให้ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของท่านนอกเหนือจากความจำเป็นในการให้บริการในนามของเราหรือเพื่อปฏิบัติตามข้อกฎหมายที่กำหนด
          เราจะทำการแบ่งปันข้อมูลให้แก่ผู้ให้บริการที่มีนโยบายความเป็นส่วนตัวคล้ายกับเราหรือผู้ให้บริการที่ยินยอมที่จะผูกพันต่อนโยบายของเราที่เกี่ยวข้องกับข้อมูลส่วนบุคคล
          ผู้ให้บริการของเราจะได้รับข้อมูลส่วนบุคคลที่พวกเขาต้องการเพื่อปฏิบัติตามการทำงานที่กำหนดไว้
          และเราจะไม่อนุญาตให้พวกผู้ให้บริการนั้นใช้หรือเปิดเผยข้อมูลส่วนบุคคลเพื่อการตลาดของพวกเขาเองหรือเพื่อวัตถุประสงค์อื่น
          ๆ
        </p>
      ),
    },
    {
      title: 'ความเป็นส่วนตัวของผู้เยาว์',
      scrollTo: 'privacy-of-childrend',
      content: (
        <Fragment>
          <p>
            เราจะไม่ทำการเก็บรวบรวมข้อมูลจากผู้เยาว์ที่มีอายุต่ำกว่า 20 ปี
            หากท่านมีอายุที่ต่ำกว่า 20 ปี
            โปรดอย่าทำการนำส่งข้อมูลส่วนบุคคลของท่านผ่านเว็บไซต์ PDPA Pro
            หรือบริการ
            เราขอแนะนำให้ผู้ปกครองและผู้มีอำนาจจัดการแทนโดยชอบด้วยกฎหมายทำการสังเกตการณ์การใช้งานอินเทอร์เน็ตของผู้เยาว์และช่วยเหลือในการบังคับใช้นโยบายฉบับนี้โดยการชี้นำให้ผู้เยาว์นั้นไม่ทำการนำส่งข้อมูลส่วนบุคคลเข้ามาในเว็บไซต์
            PDPA Pro หรือบริการโดยไม่ได้รับอนุญาต
          </p>
          <p>
            หากท่านมีเหตุผลที่เชื่อได้ว่าได้มีผู้เยาว์ที่อายุต่ำกว่า 20 ปี
            ได้ทำการนำส่งข้อมูลส่วนบุคคลผ่านเว็บไซต์ PDPA Pro หรือบริการ
            โปรดติดต่อเรา ท่านจะต้องมีอายุไม่ต่ำไปกว่า 20 ปี
            ในการให้ความยินยอมที่จะประมวลผลข้อมูลส่วนบุคคลของท่าน (ในบางประเทศ
            เราอาจยินยอมให้ผู้ปกครองของท่านหรือผู้มีอำนาจจัดการแทนโดยชอบด้วยกฎหมายให้กระทำได้ในนามของท่าน)
          </p>
        </Fragment>
      ),
    },
    {
      title: 'จดหมายข่าวสาร',
      scrollTo: 'newsletters',
      content: (
        <Fragment>
          <p>
            เรานำเสนอจดหมายข่าวสารอิเล็กทรอนิกส์ซึ่งท่านสามารสมัครใจที่จะสมัครได้ตลอดเวลา
            เราให้คำมั่นว่าจะรักษาที่อยู่อีเมลของท่านไว้ให้เป็นความลับและจะไม่ทำการเปิดเผยที่อยู่อีเมลของท่านให้กับบุคคลที่สามเว้นแต่ได้รับอนุญาตเอาไว้ในส่วนของการใช้ข้อมูลและการประมวลผลหรือเพื่อวัตถุประสงค์ในการใช้ผู้ให้บริการบุคคลที่สามในการส่งอีเมลดังกล่าว
            เราจะเก็บรักษาข้อมูลที่ส่งทางอีเมลตามกฎหมายและข้อบังคับที่บังคับใช้
          </p>
          <p>
            อีเมลทั้งหมดที่ส่งจากเราจะระบุอย่างชัดเจนว่าอีเมลนั้นมาจากใครและให้ข้อมูลที่ชัดเจนเกี่ยวกับวิธีการติดต่อผู้ส่ง
            ท่านอาจเลือกที่จะหยุดรับจดหมายข่าวหรืออีเมลการตลาดของเราโดยทำตามคำแนะนำในการยกเลิกการสมัครที่รวมอยู่ในอีเมลเหล่านี้หรือติดต่อเรา
            อย่างไรก็ตาม ท่านจะยังคงได้รับอีเมลเกี่ยวกับธุรกรรมที่จำเป็น
          </p>
        </Fragment>
      ),
    },
    {
      title: 'คุกกี้',
      scrollTo: 'cookies',
      content: (
        <Fragment>
          <p>
            เว็บไซต์ PDPA Pro ใช้ “คุกกี้”
            เพื่อเพิ่มประสบการณ์การใช้งานของท่านให้สมบูรณ์และมีประสิทธิภาพมากขึ้น
            คุกกี้ คือ
            ไฟล์ข้อความที่เราจัดเก็บไว้ในฮาร์ดไดรฟ์ของท่านโดยเว็บเพจเซิร์ฟเวอร์
            คุกกี้ไม่สามารถใช้เพื่อเปิดโปรแกรมหรือเพื่อนำส่งไวรัสเข้าสู่คอมพิวเตอร์ของท่าน
            คุกกี้ถูกเลือกใช้ให้เป็นเอกลักษณ์แก่ท่านและจะสามารถอ่านได้โดยเว็บเซิร์ฟเวอร์ของโดเมนที่ได้นำคุกกี้มาใช้กับท่าน
          </p>
          <p>
            เราอาจใช้คุกกี้เพื่อเก็บรวบรวม จัดเก็บ
            และติดตามข้อมูลเพื่อวัตถุประสงค์ทางสถิติเพื่อดำเนินการเว็บไซต์ PDPA
            Pro และบริการ ท่านความสามารถเลือกได้ว่าจะยอมรับหรือปฏิเสธคุกกี้
            เว็บเบราว์เซอร์ส่วนใหญ่ยอมรับคุกกี้โดยอัตโนมัติ
            แต่โดยปกติท่านสามารถทำการแก้ไขการตั้งค่าเบราว์เซอร์ของท่านเพื่อปฏิเสธการใช้คุกกี้ได้หากท่านต้องการ
            หากท่านเลือกที่จะปฏิเสธคุกกี้ท่านจะไม่สามารถใช้และพบกับคุณสมบัติของเว็บไซต์
            PDPA Pro และบริการได้
          </p>
        </Fragment>
      ),
    },
    {
      title: 'คุกกี้คืออะไร',
      scrollTo: 'what-are-cookies',
      content: (
        <Fragment>
          <p>
            คุกกี้คือไฟล์ข้อมูลขนาดเล็กที่จัดเก็บในรูปแบบไฟล์ข้อความที่ถูกบันทึกเอาไว้ในคอมพิวเตอร์ของท่านหรืออุปกรณ์อื่นเมื่อมีการโหลดหน้าเว็บไซต์ในเบราว์เซอร์
            โดยได้ใช้กันอย่างแพร่หลายในการจดจำท่านและความชอบของท่านไม่ว่าจะเป็นการเข้าชมเพียงครั้งเดียว
            (ผ่าน &quot;คุกกี้เซสชัน&quot;) หรือสำหรับการเข้าชมซ้ำหลายครั้ง
            (โดยใช้ &quot;คุกกี้ถาวร&quot;)
          </p>
          <p>
            คุกกี้เซสชัน
            เป็นคุกกี้ชั่วคราวที่ใช้ระหว่างการเยี่ยมชมเว็บไซต์ของท่านและคุกกี้จะหมดอายุเมื่อท่านปิดเว็บเบราว์เซอร์
          </p>
          <p>
            คุกกี้ถาวรใช้เพื่อจดจำการตั้งค่าของท่านภายในเว็บไซต์ของเราและยังคงอยู่บนคอมพิวเตอร์ตั้งโต๊ะหรืออุปกรณ์มือถือของท่านแม้ว่าท่านจะปิดเบราว์เซอร์หรือรีสตาร์ทคอมพิวเตอร์ของท่านก็ตาม
            คุกกี้เหล่านี้ให้ประสบการณ์ที่สม่ำเสมอและมีประสิทธิภาพสำหรับท่านในขณะที่เยี่ยมชมเว็บไซต์ของเราหรือใช้บริการของเรา
          </p>
          <p>
            คุกกี้อาจมีการตั้งค่าโดยเว็บไซต์
            (&quot;คุกกี้ของบุคคลที่หนึ่ง&quot;)
            หรือโดยบุคคลที่สามเช่นผู้ที่ให้บริการเนื้อหาหรือให้บริการโฆษณาหรือการวิเคราะห์บนเว็บไซต์
            (&quot;คุกกี้ของบุคคลที่สาม&quot;)
            บุคคลที่สามเหล่านี้สามารถจดจำท่านได้เมื่อท่านเยี่ยมชมเว็บไซต์ของเราและเมื่อท่านเยี่ยมชมเว็บไซต์อื่น
            ๆ
          </p>
        </Fragment>
      ),
    },
    {
      title: 'คุกกี้ที่เราใช้งาน',
      scrollTo: 'what-type-of-cookies-do-we-use',
      content: '',
    },
    {
      title: 'คุกกี้ที่มีความจำเป็นอย่างยิ่ง (Necessary Cookies)',
      scrollTo: 'necessary-cookies',
      content: (
        <p>
          คุกกี้ที่มีความจำเป็นอย่างยิ่งช่วยให้เราสามารถนำเสนอประสบการณ์ที่ดีที่สุดเมื่อท่านเข้าถึงและสำรวจเว็บไซต์ของเราและใช้งานคุณสมบัติต่างๆ
          ตัวอย่างเช่น
          คุกกี้เหล่านี้แจ้งให้เราทราบว่าท่านได้ทำการสร้างบัญชีและได้ลงชื่อเข้าใช้บัญชีนั้นเพื่อเข้าถึงเนื้อหา
        </p>
      ),
      useH3: true,
      isSub: true,
    },
    {
      title: 'คุกกี้เพื่อการทำงานของเว็บไซต์ (Functionality Cookies)',
      scrollTo: 'functionality-cookies',
      content: (
        <p>
          คุกกี้ที่มีความจำเป็นอย่างยิ่งช่วยให้เราสามารถนำเสนอประสบการณ์ที่ดีที่สุดเมื่อท่านเข้าถึงและสำรวจเว็บไซต์ของเราและใช้งานคุณสมบัติต่างๆ
          ตัวอย่างเช่น
          คุกกี้เหล่านี้แจ้งให้เราทราบว่าท่านได้ทำการสร้างบัญชีและได้ลงชื่อเข้าใช้บัญชีนั้นเพื่อเข้าถึงเนื้อหา
        </p>
      ),
      useH3: true,
      isSub: true,
    },
    {
      title: 'คุกกี้เพื่อการวิเคราะห์/เพื่อประสิทธิภาพ (Analytical Cookies)',
      scrollTo: 'analytic-cookies',
      content: (
        <p>
          คุกกี้เหล่านี้ช่วยให้เราและการบริการของบุคคลที่สามสามารถรวบรวมข้อมูลที่รวบรวมเพื่อวัตถุประสงค์ทางสถิติเกี่ยวกับวิธีที่ผู้เยี่ยมชมของเราใช้งานเว็บไซต์
          คุกกี้เหล่านี้จะไม่มีข้อมูลส่วนบุคคล เช่น ชื่อ และที่อยู่อีเมล
          และจะใช้เพื่อช่วยให้เราปรับปรุงประสบการณ์การใช้งานเว็บไซต์ของท่าน
        </p>
      ),
      useH3: true,
      isSub: true,
    },
    {
      title: 'คุกกี้โซเชียลมีเดีย (Social Media Cookies)',
      scrollTo: 'social-media-cookies',
      content: (
        <Fragment>
          <p>
            คุกกี้ของบุคคลที่สามจากเว็บไซต์สื่อสังคมออนไลน์ (เช่น Facebook,
            Twitter และอื่น ๆ ) เพื่อช่วยให้เราติดตามผู้ใช้สื่อสังคมออนไลน์
            เมื่อพวกเขาเยี่ยมชมเว็บไซต์ของเรา
            โดยใช้เครื่องมือในการติดแท็กที่จัดเตรียมไว้โดยสื่อสังคมออนไลน์เหล่านั้น
          </p>
          <p>
            คุกกี้เหล่านี้ยังใช้สำหรับการติดตามเหตุการณ์และเพื่อวัตถุประสงค์ในการการทำโฆษณาออนไลน์
            โดยข้อมูลใด ๆ
            ที่เก็บรวบรวมด้วยเครื่องมือแท็กเหล่านี้จะถูกนำไปใช้ตามนโยบายความเป็นส่วนตัวของเรา
            และเราจะไม่รวบรวมหรือแบ่งปันข้อมูลส่วนบุคคลใด ๆ
            ที่สามารถระบุตัวตนของผู้ใช้ได้
          </p>
          <List>
            <li>
              Google Analytics -
              การสร้างสถิติเกี่ยวกับวิธีที่ผู้เยี่ยมชมใช้เว็บไซต์โดยที่ไม่ระบุตัวตน
              คุกกี้เหล่านี้ใช้เพื่อแยกแยะผู้ใช้
              เราใช้คุกกี้เหล่านี้เพื่อปรับปรุงในแง่ของประสบการณ์ของผู้ใช้บนเว็บไซต์ของเราเท่านั้นและเพื่อทราบว่าเนื้อหาใดของเว็บไซต์ที่ได้รับความสนใจ
              มีการเข้าชมหรือคลิกบ่อยที่สุด (ชื่อ: _gid (หมดอายุใน 24 ชั่วโมง)
              ชื่อ:_ga (หมดอายุใน 2 ปี))
            </li>
            <li>
              Hotjar – คุกกี้ที่เก็บ ติดตามและวิเคราะห์พฤติกรรมของผู้ใช้งาน
              โดยจะปรากฏออกมาในรูปแบบเฉดสี (Heatmap) (ชื่อ: hjIncludedInSample
              (หมดอายุใน 1 ปี)
            </li>
          </List>
        </Fragment>
      ),
      useH3: true,
      isSub: true,
    },
    {
      title:
        'เรามีการใช้เว็บบีคอน (web beacon) หรือพิกเซลการติดตาม (tracking pixel) หรือไม่',
      scrollTo: 'do-we-use-web-beacons-or-tracking-pixels',
      content: (
        <Fragment>
          <p>
            อีเมลของเราอาจมี &quot;เว็บบีคอน&quot; (หรือ
            &quot;พิกเซลการติดตาม&quot;)
            เพื่อแจ้งให้เราทราบว่าอีเมลของเรามีการเปิดและตรวจสอบการคลิกผ่านลิงก์หรือโฆษณาภายในอีเมลหรือไม่
          </p>
          <p>
            เราอาจใช้ข้อมูลนี้เพื่อวัตถุประสงค์รวมถึงการพิจารณาว่าอีเมลใดที่น่าสนใจสำหรับผู้ใช้มากกว่าและเพื่อสอบถามว่าผู้ใช้ที่ไม่เปิดอีเมลของเรามีความประสงค์ที่จะรับอีเมลต่อไปหรือไม่
          </p>
          <p>
            พิกเซลจะถูกลบเมื่อท่านลบอีเมล
            หากท่านไม่ต้องการดาวน์โหลดพิกเซลลงในอุปกรณ์ของท่าน
            ท่านควรอ่านอีเมลในรูปแบบข้อความธรรมดาหรือปิดการแสดงรูปภาพ
          </p>
        </Fragment>
      ),
    },
    {
      title: 'ตัวเลือกคุกกี้ของท่านมีอะไรบ้าง',
      scrollTo: 'what-are-your-cookie-options',
      content: (
        <Fragment>
          <p>
            หากท่านไม่ชอบแนวคิดเกี่ยวกับคุกกี้หรือคุกกี้ในบางประเภท
            ท่านสามารถเปลี่ยนแปลงการตั้งค่าเบราว์เซอร์ของท่านเพื่อลบคุกกี้ที่ตั้งค่าไว้แล้วและไม่ทำการยอมรับคุกกี้ใหม่
            หากต้องการเรียนรู้เพิ่มเติมเกี่ยวกับวิธีการหรือเรียนรู้เพิ่มเติมเกี่ยวกับคุกกี้
            โปรดไปที่ internetcookies.org
          </p>
          <p>
            อย่างไรก็ตาม โปรดทราบว่าหากท่านลบคุกกี้หรือไม่ยอมรับคุกกี้
            ท่านอาจไม่สามารถใช้ระบบการทำงานได้ทั้งหมดของเว็บไซต์ PDPA Pro
            และบริการได้
          </p>
        </Fragment>
      ),
    },
    {
      title: 'การส่งสัญญาณห้ามติดตาม',
      scrollTo: 'do-not-track-signals',
      content: (
        <p>
          เบราว์เซอร์บางตัวอาจมีคุณสมบัติห้ามติดตาม (Do Not Track)
          ที่ส่งสัญญาณไปยังเว็บไซต์ที่ท่านได้เยี่ยมชมว่าท่านไม่ต้องการให้มีการติดตามกิจกรรมออนไลน์ของท่าน
          การติดตามไม่เหมือนกับการใช้หรือเก็บรวบรวมข้อมูลที่เกี่ยวข้องกับเว็บไซต์
          เพื่อจุดประสงค์เหล่านี้การติดตามหมายถึงการเก็บรวบรวมข้อมูลส่วนบุคคลที่สามารถระบุตัวตนได้จากผู้บริโภคที่ใช้หรือเยี่ยมชมเว็บไซต์หรือบริการออนไลน์ในขณะที่พวกเขาย้ายไปตามเว็บไซต์ต่างๆ
          ในช่วงเวลาหนึ่ง เว็บไซต์ PDPA Pro
          ไม่มีการติดตามผู้เยี่ยมชมเมื่อในช่วงเวลาหนึ่งและในเว็บไซต์ของบุคคลที่สาม
          อย่างไรก็ตาม
          เว็บไซต์ของบุคคลที่สามบางแห่งอาจมีการติดตามกิจกรรมการท่องเว็บของท่านเมื่อพวกเขาให้บริการเนื้อหาแก่ท่านซึ่งช่วยให้พวกเขาสามารถปรับแต่งสิ่งที่พวกเขานำเสนอให้แก่ท่านได้
        </p>
      ),
    },
    {
      title: 'การเชื่อมต่อไปยังเว็บไซต์อื่น',
      scrollTo: 'links-to-other-websites',
      content: (
        <p>
          เว็บไซต์ PDPA Pro
          มีลิงก์ที่เชื่อมต่อไปยังเว็บไซต์อื่นที่ไม่ได้เป็นเจ้าของหรือควบคุมโดยเรา
          โปรดทราบว่าเราจะไม่รับผิดชอบต่อแนวทางการปฏิบัติทางด้านความเป็นส่วนตัวของเว็บไซต์อื่น
          ๆ หรือบุคคลที่สามดังกล่าว ดังนั้น
          เราขอแนะนำให้ท่านได้ตระหนักเมื่อท่านได้ออกจากเว็บไซต์ของเราและอ่านนโยบายความเป็นส่วนตัวของแต่ละเว็บไซต์ที่อาจมีการเก็บรวบรวมข้อมูลส่วนบุคคล
        </p>
      ),
    },
    {
      title: 'การรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล',
      scrollTo: 'information-security',
      content: (
        <Fragment>
          <p>
            เรารักษาความปลอดภัยข้อมูลที่ท่านให้ไว้บนเซิร์ฟเวอร์คอมพิวเตอร์ภายใต้การควบคุม
            สภาพแวดล้อมที่ปลอดภัย
            ได้รับการปกป้องจากการเข้าถึงการใช้งานหรือการเปิดเผยโดยไม่ได้รับอนุญาต
            เรารักษามาตรการป้องกันด้านการบริหารเทคนิคและทางกายภาพที่สมเหตุสมผลเพื่อป้องกันการเข้าถึง
            การใช้ การแก้ไข
            และการเปิดเผยข้อมูลส่วนบุคคลโดยไม่ได้รับอนุญาตที่อยู่ภายใต้การควบคุมและดูแล
            อย่างไรก็ตาม
            เราไม่สามารถรับประกันการส่งข้อมูลผ่านอินเทอร์เน็ตหรือเครือข่ายไร้สายได้
            ดังนั้น ในขณะที่เราพยายามปกป้องข้อมูลส่วนบุคคลของท่าน ท่านรับทราบว่า
            (1)
            มีข้อจำกัดด้านความปลอดภัยและความเป็นส่วนตัวของอินเทอร์เน็ตซึ่งอยู่นอกเหนือการควบคุมของเรา
            (2) ความปลอดภัย ความสมบูรณ์ และความเป็นส่วนตัวของข้อมูลใด ๆ
            และข้อมูลทั้งหมดที่แลกเปลี่ยนระหว่างท่านและเว็บไซต์ของเราจะไม่สามารถรับประกันได้
            และ (3)
            ข้อมูลและข้อมูลดังกล่าวอาจถูกดูหรือถูกดัดแปลงโดยบุคคลที่สามในระหว่างการถ่ายโอนแม้ว่าจะได้พยายามอย่างเต็มที่แล้วก็ตาม
          </p>
          <p>
            <strong>เอ็นเดต้าธอธได้รับการรับรองโดย ISO27001:2013</strong>
          </p>
        </Fragment>
      ),
    },
    {
      title: 'การรั่วไหลของข้อมูล',
      scrollTo: 'data-breach',
      content: (
        <p>
          ในกรณีที่เราตรวจพบว่าความปลอดภัยของเว็บไซต์ PDPA Pro
          ได้ถูกบุกรุกหรือข้อมูลส่วนบุคคลของผู้ใช้ถูกเปิดเผยต่อบุคคลที่สามที่ไม่เกี่ยวข้องอันเป็นผลมาจากกิจกรรมภายนอก
          ซึ่งรวมถึงแต่ไม่จำกัดเพียง การโจมตีด้านความปลอดภัยหรือการฉ้อโกง
          เราขอสงวนสิทธิในการใช้มาตรการที่เหมาะสม ซึ่งรวมถึงแต่ไม่จำกัดเพียง
          การสอบสวนและการรายงานตลอดจนการแจ้งเตือนและให้ความร่วมมือกับหน่วยงานที่บังคับใช้กฎหมาย
          ภายใน 72 ชั่วโมงนับตั้งแต่ทราบถึงการรั่วไหลของข้อมูล
          ในกรณีที่มีการรั่วไหลของข้อมูล
          เราจะใช้ความพยายามตามความเหมาะสมในการแจ้งเตือนบุคคลที่ได้รับผลกระทบหากเราเชื่อว่ามีอาจมีความเสี่ยงตามสมควรที่จะเกิดอันตรายต่อผู้ใช้อันเป็นผลมาจากการรั่วไหลหรือหากกฎหมายกำหนดให้ต้องแจ้งให้ทราบ
          เมื่อเราทำเสร็จสิ้นแล้วเราจะโพสต์ประกาศบนเว็บไซต์ PDPA Pro
          และส่งอีเมลถึงท่าน
        </p>
      ),
    },
    {
      title: 'การเปิดเผยตามกฎหมาย',
      scrollTo: 'legal-disclosure',
      content: (
        <p>
          เราจะทำการเปิดเผยข้อมูลส่วนบุคคลใด ๆ ที่เราเก็บรวบรวม ใช้
          หรือได้รับหากกฎหมายได้มีการกำหนดหรืออนุญาต เช่น
          เพื่อปฏิบัติตามหมายศาลหรือกระบวนการทางกฎหมายที่คล้ายกัน
          และเมื่อเราเชื่อโดยสุจริตใจว่าการเปิดเผยข้อมูลเป็นสิ่งที่จำเป็นเพื่อปกป้องสิทธิ์ของเรา
          ปกป้องความปลอดภัยของท่านหรือผู้อื่น การตรวจสอบการฉ้อฉล
          หรือตอบสนองต่อคำขอของรัฐบาล ในกรณีที่เราดำเนินการเปลี่ยนแปลงทางธุรกิจ
          เช่น การควบรวมกิจการหรือการเข้าซื้อกิจการโดยบริษัทอื่น
          หรือการขายทรัพย์สินทั้งหมดหรือบางส่วน
          บัญชีผู้ใช้ของท่านและข้อมูลส่วนบุคคลอาจถูกรวมอยู่ในทรัพย์สินที่ได้โอนย้ายไป
        </p>
      ),
    },
    {
      title: 'การแก้ไขและเปลี่ยนแปลงนโยบายความเป็นส่วนตัว',
      scrollTo: 'changes-and-amendments',
      content: (
        <p>
          เราอาจเปลี่ยนแปลงนโยบายนี้เป็นครั้งคราวตามดุลยพินิจของเราและจะแจ้งให้ท่านทราบถึงการเปลี่ยนแปลงที่สำคัญใด
          ๆ ต่อวิธีการที่เราปฏิบัติต่อข้อมูลส่วนบุคคล
          เมื่อมีการเปลี่ยนแปลงเราจะแก้ไขวันที่ทำให้เป็นปัจจุบันไว้ที่ด้านล่างของหน้านี้
          เราอาจมีการแจ้งให้ท่านทราบด้วยวิธีอื่น ๆ ตามดุลยพินิจของเรา เช่น
          ข้อมูลติดต่อที่ท่านให้ไว้ นโยบายฉบับที่มีการเปลี่ยนแปลงใด ๆ
          จะมีผลทันทีเมื่อมีการประกาศนโยบายฉบับแก้ไข
          เว้นแต่จะระบุไว้เป็นอย่างอื่น
          การใช้เว็บไซต์หรือบริการของท่านที่ดำเนินต่อไปภายหลังหลังจากวันที่นโยบายฉบับแก้ไขมีผลบังคับใช้
          (หรือการกระทำอื่น ๆ ที่ระบุไว้ในขณะนั้น)
          จะถือว่าท่านให้ความยินยอมต่อการเปลี่ยนแปลงเหล่านั้น อย่างไรก็ตาม
          เราจะไม่ใช้ข้อมูลส่วนบุคคลของท่านในลักษณะที่แตกต่างจากที่ระบุไว้ในขณะที่ได้เก็บรวบรวมข้อมูลส่วนบุคคลของท่านโดยไม่ได้รับความยินยอมจากท่าน
        </p>
      ),
    },
    {
      title: 'ติดต่อเรา',
      scrollTo: 'contacting-us2',
      content: (
        <p>
          หากท่านต้องการติดต่อเราเพื่อทำความเข้าใจเพิ่มเกี่ยวกับสัญญาฉบับนี้หรือมีข้อสงสัยอื่นใดที่เกี่ยวข้อง
          ท่านสามารถติดต่อเราได้ผ่านการกรอกแบบฟอร์ม ส่งอีเมลมายัง
          dpo@ndatathoth.com หรือเขียนจดหมายส่งมายัง บริษัท เอ็นเดต้าธอธ จำกัด 7
          อาคารซัมเมอร์ พอยท์ ชั้นที่ 2 ซอยสุขุมวิท 69 แขวงพระโขนงเหนือ เขตวัฒนา
          กรุงเทพมหานคร 10110 ประเทศไทย
          <br />
          <br />
          หากท่านต้องการจะใช้สิทธิของท่าน โปรดใช้ผ่านช่องทาง
          <Link isExternal href="https://ndatathoth.pdpaform.com/">
            นี้
          </Link>
        </p>
      ),
    },
  ],
}
